import TabMenu from "../../components/custom-tab-menu/TabMenu"
import OverView from "./OverView"
import RawData from "./RawData"
import DataQualityRules from "./Rules"
import { BusinessQualityRules } from "./Rules"
import {
  addNavigationPath,
  // postDataQualityRulesAsync,
  removeNavigationPath,
  resetNavigationHistory,
  // resetRulePipelineStatus,
  resetSelectedGenAiRules,
} from "./DataQualitySlice"
import { useEffect } from "react"
import { useAppDispatch, useAppSelector } from "../../util/hooks"

export default function Quality() {
  const navigationHistory = useAppSelector(
    (state) => state.dataQuality.navigationHistory,
  )
  const activeComponent = navigationHistory[navigationHistory.length - 1]
  const dispatch = useAppDispatch()
  const selectedDataSet = useAppSelector(
    (state) => state.dataQuality.selectedDataSet,
  )
  const { selectedAiGeneratedRules, selectedExistingRules } = useAppSelector(
    (state) => state.dataQuality.dataQualityRules,
  )

  useEffect(() => {
    const handlePopState = () => dispatch(removeNavigationPath())
    window.addEventListener("popstate", handlePopState)
    return () => window.removeEventListener("popstate", handlePopState)
  }, [dispatch])

  useEffect(() => {
    dispatch(resetNavigationHistory())
  }, [dispatch])

  useEffect(() => {
    if (navigationHistory.length > 0) {
      const paths = [
        "/ai-enabled-quality",
        "/dataset-selected-sales",
        "/quality-rules-overview",
      ]
      const path = paths[navigationHistory.length - 1] || paths[0]
      window.history.pushState({ component: path }, "", `#${path}`)
    }
  }, [navigationHistory])

  const QualityChecksTabs = [
    { title: "Raw Data", content: <RawData /> },
    {
      title: "Data Models",
      content: (
        <div className="flex h-[10rem] w-full items-center justify-center bg-white my-4 rounded-[0.5rem]">
          Coming Soon
        </div>
      ),
    },
  ]

  const RulesTabs = [
    { title: "Data Quality", content: <DataQualityRules /> },
    { title: "Business Quality", content: <BusinessQualityRules /> },
  ]

  // For now, only Data Quality Selected Rules is being dispatched
  const handleRunClick = () => {
    // const payload = {
    //   ai_generated_rules: selectedAiGeneratedRules,
    //   raw_data_name: selectedDataSet,
    // }
    // dispatch(postDataQualityRulesAsync(payload)).then(() => {
    //   dispatch(addNavigationPath("Quality Rules Overview"))
    //   dispatch(resetSelectedGenAiRules())
    //   dispatch(resetRulePipelineStatus())
    // })

    dispatch(addNavigationPath("Quality Rules Overview"))
    dispatch(resetSelectedGenAiRules())
    // dispatch(resetRulePipelineStatus())
  }

  return (
    <div className="px-1 flex flex-col min-w-[1000px]">
      <div className="flex my-3 justify-between" />

      {/* Navigation Info */}
      <div className="flex gap-1">
        {navigationHistory.map((item, index) => (
          <p
            className={`font-semibold ${
              index === navigationHistory.length - 1
                ? "text-black"
                : "text-[#BCBCBC]"
            }`}
            key={index}
          >
            {item + (index < navigationHistory.length - 1 ? " > " : "")}
          </p>
        ))}
      </div>

      {/* Tabs or Overview */}
      <div className="flex my-3">
        {activeComponent === "AI Enabled Quality" ? (
          <TabMenu tabs={QualityChecksTabs} defaultActiveTab={0} />
        ) : activeComponent ===
          `Dataset Selected (${
            selectedDataSet.charAt(0).toUpperCase() +
            selectedDataSet.slice(1).toLowerCase()
          })` ? (
          <div className="flex flex-col w-full">
            <TabMenu tabs={RulesTabs} defaultActiveTab={0} />
            <div className="flex w-full justify-end gap-2">
              <button
                onClick={handleRunClick}
                className={`px-4 mr-10 h-7 bg-dpTheme-main text-white rounded-md text-xs ${
                  selectedAiGeneratedRules.length === 0 &&
                  selectedExistingRules.length === 0
                    ? "opacity-60"
                    : "cursor-pointer transition duration-300 ease-in-out transform hover:bg-dpTheme-main hover:scale-105 hover:shadow-lg active:scale-95 active:shadow-inner focus:outline-none"
                }`}
                disabled={
                  selectedAiGeneratedRules.length === 0 &&
                  selectedExistingRules.length === 0
                }
              >
                Run QC Check
              </button>
            </div>
          </div>
        ) : (
          <OverView />
        )}
      </div>
    </div>
  )
}
